import React, { useEffect } from "react"
import "./Artists.scss"
import StarRedSvg from "@images/icon/star/icn-star-red.svg"
import IconYoutubeSvg from "@images/icon/icn-youtube.svg"
import { StaticImage } from "gatsby-plugin-image"

const Artists = () => {
  useEffect(() => {
    // YouTube Subscribe Buttonのスクリプトをロード
    const script = document.createElement("script")
    script.src = "https://apis.google.com/js/platform.js"
    script.async = true
    document.body.appendChild(script)
  }, [])
  return (
    <>
      <section className="artists" id="talents">
        <div className="artists-inner">
          <div className="artists-container">
            <h2 className="section-title artists-title">Talents</h2>
            <div className="unit">
              <h3 className="unit-name">Voltail</h3>
              <div className="card-items">
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Terra404</p>
                    <a
                      href="https://www.youtube.com/@V4Terra404"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-Terra404"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/terra404.png"
                          alt="Terra404"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@V4Terra404"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-Terra404"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-Terra404"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UCnwJNXSulGjqu2QKcmFAMxg"
                          data-layout="default"
                          data-count="default"
                          style={{
                            width: "200px",
                            height: "100px",
                            backgroundColor: "lightblue",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Rara Rocora</p>
                    <a
                      href="https://www.youtube.com/@RaraRocora"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-RaraRocora"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/rara-rocora.png"
                          alt="Rara Rocora"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@RaraRocora"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-RaraRocora"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-RaraRocora"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UCJmMPjJSRDOSfQKHHUs1efQ"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Poma Pon</p>
                    <a
                      href="https://www.youtube.com/@Poma_Pon"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-PomaPon"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/poma-pon.png"
                          alt="Poma Pon"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@Poma_Pon"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-PomaPon"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-PomaPon"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UCWChGhf3iYh9C_zAUNe9nag"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Lyko Lianna</p>
                    <a
                      href="https://www.youtube.com/@LykoLianna"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-LykoLianna"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/lyko-lianna.png"
                          alt="Lyko Lianna"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@LykoLianna"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-LykoLianna"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-LykoLianna"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UC1nhjH-Jrh7GH9y0Fma-dGw"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="unit">
              <h3 className="unit-name">Lunalia</h3>
              <div className="card-items">
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Yumi the Witch</p>
                    <a
                      href="https://www.youtube.com/@YumitheWitch"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-YumiTheWitch"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/yumi-the-witch.png"
                          alt="Yumi the Witch"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@YumitheWitch"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-YumiTheWitch"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-YumiTheWitch"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UC1JnagrqjTzERqfpNtRfx1A"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">REM Kanashibari</p>
                    <a
                      href="https://www.youtube.com/@REMKanashibari"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-REMKanashibari"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/rem-kanashibari.png"
                          alt="REM Kanashibari"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@REMKanashibari"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-REMKanashibari"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-REMKanashibari"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UCbZZlqASU668-wyW1K2kYBw"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Dr.NOVA(e)</p>
                    <a
                      href="https://www.youtube.com/@DrNovae"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-Dr.NOVA(e)"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/dr-nova(e).png"
                          alt="Dr.NOVA(e)"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@DrNovae"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-Dr.NOVA(e)"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-Dr.NOVA(e)"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UC2Ne6dDcFxnM2hCBLii3IUg"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Alias Anono</p>
                    <a
                      href="https://www.youtube.com/@AliasAnono"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-AliasAnono"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/alias-anono.png"
                          alt="Alias Anono"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@AliasAnono"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-AliasAnono"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-AliasAnono"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UCEY9CnSH0n0QKmY2Q-OH7Zw"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="unit">
              <h3 className="unit-name">Petalight</h3>
              <div className="card-items">
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Yae Yugiri</p>
                    <a
                      href="https://www.youtube.com/@YaeYugiri"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-YaeYugiri"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/yae-yugiri.png"
                          alt="Yae Yugiri"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@YaeYugiri"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-YaeYugiri"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-YaeYugiri"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UCbDHIS0NpXROhYjsaXQX4pA"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Mono Monet</p>
                    <a
                      href="https://www.youtube.com/@MonoMonet"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-MonoMonet"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/mono-monet.png"
                          alt="Mono Monet"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@MonoMonet"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-MonoMonet"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-MonoMonet"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UCdubotSy4pPOsiaW4MrYn3Q"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Kou Mariya</p>
                    <a
                      href="https://www.youtube.com/@Kou_Mariya"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-KouMariya"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/kou-mariya.png"
                          alt="Kou Mariya"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/@Kou_Mariya"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-KouMariya"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-KouMariya"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UCqyL0oB2jl-5GpSg-GWZ_gw"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="unit">
              <h3 className="unit-name">Crystalis</h3>
              <div className="card-items">
                <div className="card-item">
                  <div className="card-item-inner">
                    <div className="star-red">
                      <img src={StarRedSvg} alt="" />
                    </div>
                    <p className="artists-name">Serina Maiko</p>
                    <a
                      href="https://www.youtube.com/channel/UCv1ThyE4KVYnnVY8GLftnoA"
                      target="_blank"
                      rel="noreferrer"
                      className="artists-img"
                      data-gtm-click="talents-charImg-SerinaMaiko"
                    >
                      <span className="square-frame">
                        <StaticImage
                          src="../../images/artists/serina-maiko.png"
                          alt="Serina Maiko"
                        />
                      </span>
                    </a>
                    <div className="youtube-content">
                      <a
                        href="https://www.youtube.com/channel/UCv1ThyE4KVYnnVY8GLftnoA"
                        target="_blank"
                        rel="noreferrer"
                        className="youtube-button"
                        data-gtm-click="talents-youtubeIcon-SerinaMaiko"
                      >
                        <img src={IconYoutubeSvg} alt="youtube button" />
                      </a>
                      <div
                        className="youtube-registration-button"
                        data-gtm-click="talents-youtubeSubscribe-SerinaMaiko"
                      >
                        <div
                          className="g-ytsubscribe"
                          data-channelid="UCv1ThyE4KVYnnVY8GLftnoA"
                          data-layout="default"
                          data-count="default"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Artists
